import React, {useState} from 'react';
import '../YogaOpHetWerkPage/Styles.css';
import useTitle from '../../useTitle';
import { Link } from 'react-router-dom';  // Import Link from react-router-dom
import ContactSection from '../ContactSection/Index';


const YogaOpWerk = () => {
  useTitle("Yoga voor bedrijven");
   // eslint-disable-next-line no-unused-vars
        const [isOpen, setIsOpen] = useState(false);
        // Close the navbar when a link is clicked
        const handleLinkClick = (url) => {
            setIsOpen(false); // Close the navbar
            window.location.href = url; // Force navigation to the specific URL
        };
  return (
    <>
      <div className='yogaOpHetWerkContainer'>
          <div className='yogaOpHetWerkAllContainer'>
            <div className='yogaOpHetWerkImageHeaderContainer'>
              <img src='/images/Agija-56-800.jpg' alt='yoga aan huis header' className='yogaOpHetWerkHeader'
                srcSet="
                  /images/Agija-56-800.jpg 800w,
                  /images/Agija-56-1200.jpg 1200w,
                  /images/Agija-56-1600.jpg 1600w
                "
                sizes="(max-width: 768px) 100vw, 742px" />
            </div>
            <div className='yogaOpHetWerkTextAll'>
              <div className='yogaAanHuisTitleContainer'>
                <h1 className='yogaAanHuisTitle'>Yoga voor bedrijven</h1>
              </div>

              <div className='yogaAanHuisDescriptionContainer'>
                <p>Wil je stress bij je medewerkers verminderen en tegelijk hun focus en energie verhogen?</p>
                <br />
                <p>Met yoga op het werk bied je jouw team een laagdrempelige en effectieve manier om zowel mentaal als fysiek sterker te worden, gewoon tijdens de werkdag, zonder extra verplaatsing. Sessie gaan door in regio Antwerpen. Bevindt je organisatie zich buiten deze regio? Dan bekijken we samen wat mogelijk is.</p>
                <br />
                <p>De sessies worden volledig afgestemd op de noden van jouw organisatie.</p>
                <br />
                <p>Denk aan:</p>
              </div>

              <div className='waaromYogaAanHuisDescriptionContainer'>
                <ul className='bedrijfsYogaList'>
                  <li>Het verminderen van nek- en rugklachten door zittend werk</li>
                  <li>Het verlagen van stress en werkdruk</li>
                  <li>Het verbeteren van concentratie en productiviteit</li>
                </ul>
              </div>
              
              <div className='waaromYogaAanHuisDescriptionContainer'>
                <p>De oefeningen zijn toegankelijk voor iedereen, ook zonder ervaring met yoga en kunnen plaatsvinden op kantoor of in een vergaderruimte.</p>
              </div>

              <div className='waaromYogaAanHuisTitleContainer'>
                <h2 className='waaromYogaAanHuisTitle'>Mogelijke formules</h2>
              </div>

              <div className='waaromYogaAanHuisDescriptionContainer'>
                <ul className='bedrijfsYogaList'>
                  <li><b className='bedrijfsYogaListSubTitle'>Wekelijkse of maandelijkse sessies</b><br/>Voor teams die structureel willen inzetten op welzijn</li>
                  <li><b className='bedrijfsYogaListSubTitle'>Workshops rond stress en ontspanning</b><br/>Ideaal als inspirerende sessie of teambuilding</li>
                  <li><b className='bedrijfsYogaListSubTitle'>Korte "yoga breaks" (30-45 min)</b><br/>Perfect als energizer tijdens de werkdag of middagpauze</li>
                </ul>
                <p>Een korte sessie kan al een groot verschil maken: medewerkers keren terug naar hun werk met meer rust, focus en energie.</p>
              </div>

              <div className='ontdekYogaOpHetWerkTitleContainer'>
                <h2 className='ontdekYogaOpHetWerkTitle'>Interesse om yoga op de werkvloer te integreren? Vraag een vrijblijvende offerte aan.</h2>
              </div>

              <div className='ontdekYogaOpHetWerkButtonContainer'>
                <Link onClick={() => handleLinkClick('/contact')}  className='ontdekYogaOpHetWerk'>Vraag hier je vrijblijvende offerte aan</Link>
              </div>

            </div>
          </div>
      </div>

      {/* Contact/Menu Section */}
      <ContactSection />
    </>
  )
}

export default YogaOpWerk;
